export default "__VITE_ASSET__DJdBbcYi__"